module.exports = __webpack_public_path__ + "img/region_california.3883584d.svg";